import { render, staticRenderFns } from "./VModalLink.vue?vue&type=template&id=937d316c"
import script from "./VModalLink.vue?vue&type=script&lang=js"
export * from "./VModalLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports